
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12.077","height":"10.016","viewBox":"0 0 12.077 10.016"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_1225","data-name":"Group 1225","transform":"rotate(90 6.038 6.039)"}},[_c('g',{attrs:{"id":"Group_328","data-name":"Group 328"}},[_c('path',{attrs:{"id":"path","data-name":"Path 2087","d":"M1.471 2.074l6.4 3.964L1.471 10V2.074M.716 0A.717.717 0 000 .716v10.648a.715.715 0 00.716.714.7.7 0 00.374-.108l8.588-5.324a.713.713 0 000-1.214L1.09.108A.723.723 0 00.716 0z","fill":"#34bbda"}})])])])
          )
        }
      }
    